import { LicenseInfo } from '@mui/x-license';
LicenseInfo.setLicenseKey('80f53660f5f780daff60a757487567adTz03MjUzMSxFPTE3MjMzNTM1NDkwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');
